// Authentication configuration for zWarehouse
// This file handles reading credentials from environment variables

// Get the single username and password from environment variables
export const getCredentials = () => {
    const username = process.env.REACT_APP_USERNAME;
    const password = process.env.REACT_APP_PASSWORD;
    
    if (!username || !password) {
        throw new Error('REACT_APP_USERNAME and REACT_APP_PASSWORD must be set in environment variables');
    }
    
    return { username, password };
};

// Export for testing or direct access
export const credentials = getCredentials(); 